import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 0,
    tokenName: 'ORI',
    stakingTokenName: QuoteToken.ORI,
    stakingTokenAddress: '0x0575f8738EFdA7F512e3654F277C77e80C7d2725',
    contractAddress: {
      97: '0xc605158c53dac91E8650849690881F77f182442c',
      250: '0x90Df158ff7c31aD1d81ddDb1D8ab9d0eCBCeDa20',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://hyperjump.fi/',
    harvest: true,
    tokenPerSecond: '10',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 93,
    tokenName: 'LINK',
    stakingTokenName: QuoteToken.ORI,
    stakingTokenAddress: '0x85c85647e1A79c2b8bc3Ed2B6a1DdE326eeC66c5',
    contractAddress: {
      97: '',
      250: '0x3901fE4A9b2B0d67B2705443Ec8aEB1e1ae39b89',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://vaults.hyperjump.fi/',
    harvest: true,
    tokenPerSecond: '0.999',
    sortOrder: 999,
    isFinished: false,
    tokenDecimals: 18,
  },
]

export default pools
